module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "small-title pull-right"
  }, [_c('hr'), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "services-text-main-container",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "services-main-container"
  }, [_c('h1', [_vm._v(" " + _vm._s(_vm.state.subTitle) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.pTextTop)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services-icon-text-container"
  }, [_c('div', {
    staticClass: "left-icon-text"
  }, [_c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_logistica_int.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText1))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_fronterizo.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText2))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_operador.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4",
    domProps: {
      "innerHTML": _vm._s(_vm.state.serviceText3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_urgentes.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText4))])])]), _vm._v(" "), _c('div', {
    staticClass: "right-icon-text"
  }, [_c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_transporte.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText5))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_entrega.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4",
    domProps: {
      "innerHTML": _vm._s(_vm.state.serviceText6)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_direccion.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText7))])]), _vm._v(" "), _c('div', {
    staticClass: "service-icontext-container"
  }, [_c('img', {
    staticClass: "img-left-align",
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/icons/icon_almacen.png"),
      "width": "100px"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "service-h4"
  }, [_vm._v(_vm._s(_vm.state.serviceText8))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-10 pull-right contenedor-equipo",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "data-aos": "fade-in"
    }
  }, [_c('div', {
    staticClass: "cornered"
  }), _vm._v(" "), _c('div', {
    staticClass: "equip-div"
  }, _vm._l((_vm.state.flotilla), function(inv, key, index) {
    return _c('div', {
      key: key,
      staticClass: "eq-items pull-left hidden",
      attrs: {
        "id": index
      }
    }, [_c('h1', [_vm._v(_vm._s(_vm.state.titleFlotilla) + "\n                "), _c('br'), _vm._v(" "), _c('div', [_c('span', [_vm._v(" " + _vm._s(inv.texto))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "transform": "skew(10deg)"
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/infraestructura",
        "tag": "a"
      }
    }, [_c('h4', {
      staticStyle: {
        "color": "white",
        "background-color": "#d51218",
        "padding": "10px"
      }
    }, [_vm._v(_vm._s(_vm.state.btnVerMas))])])], 1)]), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.invImgUrl(inv.img)
      }
    })])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b4fa88a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ServicesPage.vue
// module id = 143
// module chunks = 0